import { useEffect } from 'react'

/**
 * Locks body scroll by toggling the 'no-scroll' class on <body>.
 * @param {boolean} isLocked - If true, disables body scroll.
 */
export default function useBodyScrollLock(isLocked) {
  useEffect(() => {
    if (isLocked) {
      document.body.classList.add('no-scroll')
    } else {
      document.body.classList.remove('no-scroll')
    }
    return () => {
      document.body.classList.remove('no-scroll')
    }
  }, [isLocked])
}
